import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { ProfileGroupsApi } from '../api/profileGroups';

export const useProfileGroupDetailQuery = (profileGroupId: number | null) => {
  const profileGroupDetailQuery = useQuery(
    profileGroupId !== null
      ? queryKey.profileGroupDetail(profileGroupId)
      : ['settings', 'profileGroupDetail', 'idle'],
    () => {
      if (profileGroupId === null) {
        return Promise.reject(new Error('profileGroupId is null'));
      }
      return ProfileGroupsApi.getDetail(profileGroupId);
    },
    {
      enabled: profileGroupId !== null,
    },
  );

  return {
    profileGroup: profileGroupDetailQuery.data,
    isLoading: profileGroupDetailQuery.isLoading,
    isError: profileGroupDetailQuery.isError,
    refetch: profileGroupDetailQuery.refetch,
  };
};
